@if(item.navCap) {
<div mat-subheader class="nav-caption">
  {{ item.navCap }}
</div>
}

@if(!item.navCap && !item.external) {
<a mat-list-item tabindex="0" (click)="onItemSelected(item)" (keydown)="$event.key === 'Enter' && onItemSelected(item)" [ngClass]="{
      'mat-toolbar mat-accent activeMenu': item.route
        ? router.isActive(item.route, true)
        : false,
      expanded: expanded,
    }" class="menu-list-item rounded-pill">
  <i-tabler name="{{ item.iconName }}" class="routeIcon" matListItemIcon></i-tabler>
  <span class="hide-menu">{{ item.displayName | translate }}</span>
  @if(item.children && item.children.length) {
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon class="indicator-icon" [class.expanded]="expanded">
      expand_more
    </mat-icon>
  </span>
  }

</a>

}


<!-- children -->
@if(expanded) {
  @for(child of item.children; track child) {
  <app-nav-item [item]="child" (click)="onSubItemSelected(child)" (keydown)="$event.key === 'Enter' && onSubItemSelected(child)" [depth]="depth + 1">
  </app-nav-item>
  }
}